import * as React from 'react';
export const aptosSvg = React.forwardRef(function aptosSvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fill: '#000',
      d: 'M0 0h32v32H0z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      fill: '#fff',
      d: 'M20.47 12.012a.864.864 0 0 1-.647-.29l-.861-.973a.675.675 0 0 0-1.013 0l-.738.834c-.242.273-.589.43-.953.43H4.637c-.33.943-.547 1.94-.633 2.973h10.97a.707.707 0 0 0 .51-.218l1.022-1.066a.676.676 0 0 1 .488-.208h.043c.193 0 .378.083.506.228l.86.973c.164.185.4.29.647.29h8.954a11.971 11.971 0 0 0-.633-2.972H20.47Zm-9.827 9.226a.707.707 0 0 0 .51-.218l1.022-1.066a.676.676 0 0 1 .488-.208h.042c.194 0 .378.083.506.227l.861.973a.863.863 0 0 0 .646.291h12.135c.455-.94.788-1.947.986-3.003H16.19a.864.864 0 0 1-.646-.291l-.86-.973a.675.675 0 0 0-1.013 0l-.739.835c-.241.273-.588.43-.953.43H4.17c.198 1.055.531 2.063.985 3.003h5.488Zm8.609-12.475a.707.707 0 0 0 .51-.218l1.022-1.066a.676.676 0 0 1 .488-.208h.042c.194 0 .378.083.506.228l.86.973c.165.185.4.29.647.29h2.308a12.025 12.025 0 0 0-9.63-4.81c-3.938 0-7.433 1.89-9.631 4.81h12.878Zm-7.792 15.45a.864.864 0 0 1-.646-.29l-.86-.973a.675.675 0 0 0-1.013 0l-.739.835c-.241.272-.588.43-.953.43h-.05a12.01 12.01 0 0 0 8.806 3.83 12.01 12.01 0 0 0 8.806-3.83l-13.35-.001Z',
    }),
  );
});
aptosSvg.defaultProps = {
  width: '32',
  height: '32',
  viewBox: '0 0 32 32',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var aptos = {
  category: 'brand',
  colorable: false,
  name: 'aptos',
  svg: aptosSvg,
};
